import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import Skeleton from '../UI/Skeleton'

class Result extends React.Component {
    render() {
        return (
            <React.Fragment>
                {
                    this.props.skeleton ?
                        <div className="result__card">
                            <Skeleton className="result__card_circle d-flex align-items-center justify-content-center d-block mr-auto" width={40} height={40} circle={true} />
                            <Skeleton className="result__card_text sm-font-size" count={3} />
                        </div>
                        :
                        <div className="result__card">
                            <div className="result__card_circle d-flex align-items-center justify-content-center">
                                <span className="md-font-size">{this.props.index < 9 ? `0${this.props.index + 1}` : this.props.index + 1}</span>
                            </div>
                            <p className="result__card_text sm-font-size">{this.props.title}</p>
                        </div>
                }
            </React.Fragment>
        )
    }
}

Result.propTypes = {
    t: PropTypes.func,
    index: PropTypes.number,
    title: PropTypes.string,
    skeleton: PropTypes.bool,
}

export default withTranslation()(Result)



// WEBPACK FOOTER //
// ./src/components/Catalog/Result.jsx